import { FaHandsHelping, FaPiggyBank, FaChartLine } from "react-icons/fa";
import "./Steps.css";

const Steps = () => {
  return (
    <section className="steps-box">
      <div className="steps">
        {/* Step 1 */}
        <div className="step">
          <FaHandsHelping className="step-icon" />
          <div className="step-text">
            <h4>Step 1: Sustainable development priorities. </h4>
            <p style={{ color: "white" }}>
              Impact Stories Fund prioritizes development goals with the
              greatest community impact by focusing on initiatives that address
              pressing local needs. The fund carefully evaluates potential
              projects, considering factors such as reach, sustainability, and
              long-term benefits. By investing in stories that showcase
              transformative change, the fund aims to inspire and catalyze
              further community development.
            </p>
          </div>
        </div>

        {/* Step 2 - Switched Icon & Text Position */}
        <div className="step reverse">
          <FaPiggyBank className="step-icon" />
          <div className="step-text">
            <h4>Step 2: Finding and filming </h4>
            <p style={{ color: "white" }}>
              Impact Stories Fund identifies promising projects through market
              analysis, stakeholder engagement, and SWOT assessments. It
              collaborates with local organizations, evaluates community needs,
              and reviews proposals. The fund then films selected initiatives,
              capturing transformative stories that inspire further development
              and foster sustainable change in communities.
            </p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="step">
          <FaChartLine className="step-icon" />
          <div className="step-text">
            <h4>Step 3: Distribution of films</h4>
            <p style={{ color: "white" }}>
              Impact Stories Fund distributes films to maximize public and donor
              viewership, fostering support for selected projects. By leveraging
              screenings, social media, and strategic partnerships, the fund
              closes the loop by generating further backing for impactful
              initiatives, inspiring continued investment and community
              engagement.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Steps;
